"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
require("../whatsNew/whatsNewList.scss");
const react_redux_1 = require("react-redux");
const whatsNewSlice_1 = require("../../../../redux/slices/whatsNewSlice");
const max_1 = __importDefault(require("lodash/max"));
const initialState = {
    title_error: false
};
class WhatsNewForm extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = initialState;
        this.resetState = () => {
            const { whatsNew: { editable: { subtitle } } } = this.props;
            this.setState(initialState);
            for (const key in subtitle) {
                this.setState({
                    title_error: false,
                    [`subtitle_error_${key}`]: false
                });
            }
        };
        this.addSubtitle = (key) => {
            const { whatsNew: { editable } } = this.props;
            this.props.setEditableWhatsNew(Object.assign(Object.assign({}, editable), { subtitle: Object.assign(Object.assign({}, editable.subtitle), { [key]: "" }) }));
        };
        this.subtitleList = obj => {
            return Object.keys(obj).map(key => {
                return (react_1.default.createElement("div", { key: key, className: "mb-10" },
                    react_1.default.createElement(core_1.TextField, { variant: "outlined", key: "title", onChange: (e) => this.onSubtitleChange(e, key), margin: "dense", name: "subtitle", multiline: false, label: "Subtitle", type: "text", error: this.state[`subtitle_error_${key}`], defaultValue: obj[key], fullWidth: true })));
            });
        };
    }
    onTitleChange(event) {
        const value = event.target.value.trim();
        this.props.setEditableWhatsNew({ title: value });
        this.setState({ title_error: false });
    }
    onSubtitleChange(event, key) {
        const { editable } = this.props.whatsNew;
        const value = event.target.value.trim();
        let tmpSubtitle = Object.assign({}, editable.subtitle);
        if (!value && Object.keys(tmpSubtitle).length > 1) {
            delete tmpSubtitle[key];
        }
        else {
            tmpSubtitle[key] = value;
        }
        this.props.setEditableWhatsNew({ subtitle: tmpSubtitle });
        this.setState({ [`subtitle_error_${key}`]: false });
    }
    validateForm() {
        const { editable } = this.props.whatsNew;
        const errors = {};
        for (const prop in editable) {
            if (typeof editable[prop] === 'object') {
                for (const key in editable[prop]) {
                    if (!editable[prop][key]) {
                        errors[`${prop}_error_${key}`] = true;
                    }
                }
            }
            else {
                if (!editable[prop]) {
                    errors[`${prop}_error`] = true;
                }
            }
        }
        this.setState(Object.assign({}, errors));
        return Object.keys(errors).length === 0;
    }
    publish() {
        const isValid = this.validateForm();
        if (!isValid)
            return false;
        const { editable } = this.props.whatsNew;
        this.props.createWhatsNew(editable);
        this.props.resetWhatsNew();
        this.resetState();
        this.props.resetParentState();
    }
    preview() {
        const isValid = this.validateForm();
        if (!isValid)
            return false;
        this.props.toggleModal();
        this.props.toggleDetailsModal();
        this.props.togglePreview();
        this.resetState();
    }
    closeModal() {
        this.props.toggleModal();
        this.props.resetWhatsNew();
        this.resetState();
    }
    render() {
        const { addModalOpen, editable } = this.props.whatsNew;
        const len = Object.keys(editable.subtitle).length;
        const nextKey = parseInt(max_1.default(Object.keys(editable.subtitle))) + 1;
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(core_1.Dialog, { className: "create-whats-new-modal", open: addModalOpen, fullWidth: true, maxWidth: 'sm', onClose: () => { this.closeModal(); } },
                react_1.default.createElement(react_1.Fragment, null,
                    react_1.default.createElement(core_1.DialogTitle, { className: "modal-title" }, "What's New"),
                    react_1.default.createElement(core_1.DialogContent, { className: "modal-body" },
                        react_1.default.createElement("form", { noValidate: true, autoComplete: "off" },
                            react_1.default.createElement("div", { className: "mb-10" },
                                react_1.default.createElement(core_1.TextField, { variant: "outlined", key: "title", onChange: (e) => this.onTitleChange(e), margin: "dense", name: "title", multiline: false, label: "Title", type: "text", error: this.state.title_error, defaultValue: editable.title, fullWidth: true })),
                            this.subtitleList(editable.subtitle))),
                    react_1.default.createElement(core_1.DialogActions, null,
                        react_1.default.createElement(core_1.Box, { visibility: len >= 3 ? "hidden" : "visible" },
                            react_1.default.createElement("label", { className: "add-new", onClick: () => this.addSubtitle(nextKey) }, "Add")),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(core_1.Button, { className: "v2-btn v2-btn-primary", variant: "contained", disableRipple: true, color: "primary", onClick: () => this.publish() }, "Publish"),
                            react_1.default.createElement(core_1.Button, { className: "v2-btn v2-btn-tertiary", variant: "contained", disableRipple: true, onClick: () => this.preview() }, "Preview")))))));
    }
}
;
const mapStateToProps = (state) => {
    const { whatsNew } = state;
    return {
        whatsNew
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        toggleAddModal: () => dispatch(whatsNewSlice_1.toggleAddModal()),
        createWhatsNew: (data) => dispatch(whatsNewSlice_1.createWhatsNew(data)),
        toggleDetailsModal: () => dispatch(whatsNewSlice_1.toggleDetailsModal()),
        togglePreview: () => dispatch(whatsNewSlice_1.togglePreview()),
        setEditableWhatsNew: (data) => dispatch(whatsNewSlice_1.setEditableWhatsNew(data)),
        resetWhatsNew: () => dispatch(whatsNewSlice_1.resetWhatsNew()),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(WhatsNewForm);
